import { getPrivateApi } from "../lib/axiosConfig";
import { Coupon } from "../types/coupons";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/coupons"

export const getCoupons = async (): Promise<Coupon[]> => {
  try {
    const { data: CouponList } = await api.get(`${endpoint}`);

    return CouponList;
  } catch (error: any) {
    const errMsg = "Erro ao buscar cupons";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
};

export const createCoupon = async (coupon: Omit<Coupon, "id" | "usageCount" | "active">): Promise<void> => {
  try {
    await api.post(`${endpoint}`, coupon);
  } catch (error: any) {
    const errMsg = "Erro ao criar cupom";
    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};

export const deleteCoupon = async (id: string): Promise<void> => {
  try {
    await api.delete(`${endpoint}/${id}`);
  } catch (error: any) {
    const errMsg = "Erro ao deletar cupom";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};

export const getTypesId = async (orderType: string): Promise<any[]> => {
  try {
    const orderTypeLower = orderType.toLocaleLowerCase();
    const { data: types } = await api.get(`/${orderTypeLower}-types`);
    return types;
  } catch (error: any) {
    const errMsg = "Erro ao buscar tipos";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
};